export default __webpack_public_path__ + "static/Graphik-LightItalic-Web-866f32c569d90e1207c844fe780c6c47.woff";